import React, { useContext } from 'react';

import { isEmptyObject } from '../../utils';
import { useProfileData } from '../../hooks/useProfileData';
import { Container } from '../Container';
import { Loader } from '../Loader';
import { MainLayout } from '../MainLayout';
import { PageContext } from '../../routes/Page';

export const LayoutProfile: React.FC = ({ children }) => {
    const { profileData } = useProfileData();

    const { currentPageData } = useContext(PageContext);

    const { hide_footer: hideFooter } = currentPageData.content;

    if (isEmptyObject(profileData)) {
        return <Loader centered />;
    }

    return (
        <MainLayout className="ProfilePage" hideFooter={hideFooter}>
            <Container sizeGroup="size-2">{children}</Container>
        </MainLayout>
    );
};
